import React from 'react';
import { Shield, Clock, TrendingUp } from 'lucide-react';
import { useCMS } from '../../context/CMSContext';

const DEFAULT_IMG = 'https://images.unsplash.com/photo-1774013603273-03507c48a0e8?crop=entropy&cs=srgb&fm=jpg&q=85';
const ICONS = { Trust: Shield, Time: Clock, Transportation: TrendingUp };

export const WhyChooseUsSection = () => {
  const cms = useCMS();
  const pillars = cms?.why_choose_us?.pillars || [];
  const image = cms?.why_choose_us?.image_url || DEFAULT_IMG;

  return (
    <section id="why-us" className="py-32 bg-slate-50 dark:bg-[#0B0F19] relative overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-2 bg-amber-500/10 text-amber-600 dark:text-amber-500 rounded-full text-sm font-bold mb-6">WHY CHOOSE US</span>
            <h2 className="font-outfit text-5xl font-black text-slate-900 dark:text-white mb-6">The Trinity of Excellence</h2>
            <p className="text-xl text-slate-700 dark:text-slate-300 mb-10">Three pillars that define our commitment to your logistics success</p>
            <div className="space-y-6">
              {pillars.map(pillar => {
                const Icon = ICONS[pillar.title] || Shield;
                return (
                  <div key={pillar.title} className="flex gap-4">
                    <div className="flex-shrink-0 w-14 h-14 bg-amber-500/10 rounded-2xl flex items-center justify-center"><Icon className="w-7 h-7 text-amber-500" /></div>
                    <div><h3 className="font-outfit text-xl font-bold text-slate-900 dark:text-white mb-2">{pillar.title}</h3><p className="text-slate-700 dark:text-slate-300">{pillar.description}</p></div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="relative">
            <img src={image} alt="Logistics" className="rounded-3xl shadow-2xl w-full h-[420px] object-cover" />
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-t from-black/20 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
};
